const customersLang = {

}

export default {
  customers: customersLang
}
